import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import FormikButton from '../../../components/formik/FormikButton';
import Form from '../../../components/utilities/Form';

export default function Confirm({ onConfirm, amountToPay, isLoading }) {
    return (
        <Container maxWidth="sm">
            <Box sx={{ my: 1 }}>
                <Typography>
                    A payment request of{' '}
                    <span className="text-success fw-bold">
                        {'KSH ' + amountToPay + ' '}
                    </span>
                    has been sent to the phone number you provided. Press
                    confirm once you input your pin and receive a message from
                    M-Pesa.
                </Typography>
            </Box>
            <Form onSubmit={onConfirm} initialValues={{ promo: '' }}>
                <FormikButton loading={isLoading} variant="contained" fullWidth>
                    Confirm
                </FormikButton>
            </Form>
        </Container>
    );
}
